export class GridCriteria {
    filter: string;
    type: 'startsWith' | 'contains';

    constructor(criteria?: { filter: string, type: 'startsWith' | 'contains' }) {
        if (criteria) {
            this.filter = criteria.filter;
            this.type = criteria.type;
        }
    }

    getCriteriaDescription(): string {
        if (this.filter) {
            return `"${(this.type == 'startsWith' ? 'Starts with' : 'Contains')}"  ${this.filter}`;
        }
        return;
    }
}
